import { SxProps, Typography } from "@mui/material";
import { IssueClosedAnimation } from "../../assets/animations";
import { CommentSubject, ISSUE_STATUSES, IssueStatus } from "../../constants";
import { Circle, PauseCircle } from "@mui/icons-material";
import { StatusChangedDialogContent } from "src/components";

interface IProps {
  issueGuid: string;
  status: IssueStatus;
  onDone: () => void;
  onCancel: () => void;
}

const IssueStatusChangedDialogContent = (props: IProps) => {
  function getIcon() {
    const iconSxProps: SxProps = {
      color: ISSUE_STATUSES.find((x) => x.id === props.status)!.color,
      width: 100,
      height: 100,
    };

    switch (props.status) {
      case IssueStatus.Closed:
        return <IssueClosedAnimation />;
      case IssueStatus.Paused:
        return <PauseCircle sx={iconSxProps} />;
      default:
        return <Circle sx={iconSxProps} />;
    }
  }

  function getContentBody() {
    switch (props.status) {
      case IssueStatus.Closed:
        return `Congratulations! You've marked this issue ${ISSUE_STATUSES.find(
          (x) => x.id === props.status
        )!.name.toUpperCase()}.`;
      default:
        return `You've marked this issue ${ISSUE_STATUSES.find((x) => x.id === props.status)!.name.toUpperCase()}.`;
    }
  }

  return (
    <StatusChangedDialogContent
      icon={getIcon()}
      title={ISSUE_STATUSES.find((x) => x.id === props.status)!.name.toUpperCase()}
      content={
        <Typography>
          {getContentBody()}
          <br />
          Please enter a comment with reasons for the change of status.
        </Typography>
      }
      commentSubjectType={CommentSubject.Issue}
      commentSubjectGuid={props.issueGuid}
      onDone={props.onDone}
      onCancel={props.onCancel}
    />
  );
};

export { IssueStatusChangedDialogContent };
